<template>
	<div class="ibox float-e-margins ibox-content" style="position: relative; height: 100%;" id="editPanel">
		<div class="form-horizontal">
			<div class="form-horizontal" id="search">
				<div class="form-group">
					<input type="hidden"  v-model="editItem.protocolId" />
					
					<label class="col-sm-1  control-label focus_color">*设备协议名</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': $v.deviceInfo.deviceProtocol.$error }">
						<input type="text" class="form-control" v-model.trim="deviceInfo.deviceProtocol" @input="$v.deviceInfo.deviceProtocol.$touch()"  maxlength="30">
			    	    <span class="form-group__message cus_message" v-if="!$v.deviceInfo.deviceProtocol.required && $v.deviceInfo.deviceProtocol.$error">设备协议名为必填项</span>
					</div>
				
					<label class="col-sm-1 control-label">品牌</label>
			 		<div class="col-sm-3" >
					<select class="form-control" v-model="deviceInfo.brandCode">
						<option v-for="option in deviceBrand" v-bind:value="option.brandCode">
							{{ option.brandName }}
						</option>
					</select>
					</div>
					
			        <label class="col-sm-1 control-label focus_color">*设备型号</label>
					<div class="col-sm-3"  v-bind:class="{ 'form-group--error': $v.deviceInfo.categoryId.$error }">
						<select class="form-control" v-model="deviceInfo.categoryId" @input="$v.deviceInfo.categoryId.$touch()" >
							<option v-for="option in deviceCategory" v-bind:value="option.id">
								{{ option.categoryNo }}
							</option>
						</select>	
						 <span class="form-group__message cus_message" v-if="!$v.deviceInfo.categoryId.required && $v.deviceInfo.categoryId.$error">型号为必填项</span>
					</div>
					
				</div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button class="btn btn-primary" @click="reset">重置</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<button v-show="mode!=='check'" class="btn btn-primary" @click="update" :disabled="!enableSubmit">确定</button>
					<button class="btn btn-primary" @click="close">关闭</button>
				</div>
			</div>
		</div>
	    </div>
		<!--   弹出框子组件        -->
		<sub-modal ref="modalMsg" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>	
		<sub-modal ref="modalWarn" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModalMsg">确定</button>
			</div>
		</sub-modal>
	</div>
</template>

<script>
	
    import SubModal from 'components/common/SubModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import { required } from 'vuelidate/lib/validators'
	export default {
		name: 'PageDeviceProtocolEdit',
		components: {
		   SubModal
		},
		props: ["editItem", "mode","deviceCategoryId","brandCode"],
		data() {
			return {				
				tipContent: '11',
				scrollTop: '',
				messageStr:'',
				deviceBrand:[],                      //设备品牌下拉框
				deviceInfo:{
					deviceProtocol:'',
					brandCode:'',	                //设备品牌
					categoryId:'',   		    	//型号
					protocolId:'',	
				},
 				categoryId:'',						//暂时存在值
									//暂时存在值
				deviceBrand:[],                      //设备品牌下拉框
				deviceCategory:[]    				//设备型号下拉列表
			}

		},
		beforeMount() {
	       this.getDeviceBrand();  
  	    },
 		watch:{
			'deviceInfo.brandCode'(val,oldval){
				
				if(val){
					this.getDeviceCategory(val);
                    this.$v.deviceInfo.deviceProtocol.$reset()
   		            this.$v.deviceInfo.categoryId.$reset() 
				}
			},
			brandCode(val){
				this.deviceInfo.deviceProtocol = this.editItem.deviceProtocol
				this.deviceInfo.brandCode = this.brandCode
			},
			'deviceInfo.deviceProtocol'(val,oldval){}
		}, 
		validations: {
			deviceInfo:{
				deviceProtocol:{
					required
				},
				categoryId:{
					required
				}
			},
		},
		computed: {
			enableSubmit: function(){
				return this.$v.deviceInfo.deviceProtocol.required && this.$v.deviceInfo.categoryId.required 
			}
		},
		
		methods: {
			close(action) {
			/*	this.deviceInfo = {
					deviceProtocol: "" ,
					brandCode:'',
					categoryId:""
				},*/
				this.deviceInfo.deviceProtocol="";
				this.deviceInfo.brandCode = "";
				this.deviceInfo.categoryId = "";
				this.deviceCategory = [] ;
				this.$emit('toClose', action);
			},
			update() {
				if(this.mode == 'edit') {
					  const para = {
						categoryId:  this.deviceInfo.categoryId, // 
						deviceProtocol: this.deviceInfo.deviceProtocol, // 
					}
					this.$http.put(process.env.API_ROOT + '/system/protocol/'+this.editItem.protocolId , para)
						.then(res => { 
							if(!res.body.success) {
								this.openMsgTip(res.body.message)
							}else
							this.close('refresh');
						},res => {
							this.openMsgTip(res.body.message);
							this.loadingstatus = false;
					}).catch(res => {
							this.openMsgTip(OPERATE_EXCEPTION);
						})
				}
				if(this.mode == 'create') { 
				    const para = {
						categoryId: this.deviceInfo.categoryId, // 
						deviceProtocol: this.deviceInfo.deviceProtocol, // 
					}
					this.$http.post(process.env.API_ROOT + '/system/protocol',para)
						.then(res => { 
							if(!res.body.success) {
								this.openMsgTip(res.body.message)
							}else{
//								this.openMsgTip(res.body.message)
							    this.close('refresh');
							}
						},res => {
							this.openMsgTip(res.body.message)
							this.loadingstatus = false;
					}).catch(res => {
							this.openModalMsg(OPERATE_EXCEPTION);
						})
				}

			},
				//重置信息
			reset: function() {
			/*	this.deviceInfo = {
					protocolId: "", //  
					deviceProtocol: "", //
					categoryNo:""
				},*/
				this.deviceInfo.deviceProtocol="";
				this.deviceInfo.brandCode = "";
				this.deviceInfo.categoryId = "";
				this.deviceCategory = [] ;
				this.deviceInfo.brandCode  = "";
				this.deviceInfo.categoryId = "";
			/*	this.deviceInfo = {
					brandCode: "",
					categoryId: ""
				}*/
			},
			// 获取设备品牌下拉列表
			getDeviceBrand(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands')
				.then( res => {
					if(res.data.success){
						this.deviceBrand= res.data.data;
						//this.getDeviceInfo();
					}else{
						this.$parent.openModal(res.body.message);
					}
					this.$parent.loadingstatus += 1;
				}, res => {
						this.$parent.openModal(res.body.message);
						this.$parent.loadingstatus += 1;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.$parent.loadingstatus += 1;
				})	
			},
	 		getDeviceCategory(val){
				//if(typeof(val)=="undefined")return;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands/'+val)
				.then( res => {
					
					if(res.body.success){
						this.deviceCategory= res.body.data;
						this.deviceInfo.categoryId = this.deviceCategoryId;
					}else{
						this.$parent.openModal(res.body.message);
					}
				}, res => {
						this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})	
			},
				 
			// 消息弹出框相关 
			closeMsgTip() {
				this.$refs.modalMsg.close();
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsg.open();
			},
			openModalMsg(ref,msg){
				this.messageStr=msg;
				this.$refs[ref].open();
			},
			closeModalMsg() {
				this.$refs.modalWarn.close();
			},

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PageDeviceProtocolEdit.vue?2e1d461f